import React, { FC, ReactElement, useState } from 'react';

import styled from 'styled-components';
import { BLUE_01, BLUE_02, WHITE } from 'utils/colors';

type NormalButtonProps = {
  secondary?: boolean;
};
const NormalButton = styled.button<NormalButtonProps>`
  display: flex;
  border-radius: 2px;
  justify-content: center;
  align-items: center;

  color: white;
  border: none;
  font-size: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  max-width: 768px;
  cursor: pointer;
  ${(props) =>
    props.disabled
      ? `
		background-color: #aaa !important;
		cursor: default;
		user-select: none;
	  `
      : ''}

  background-color: ${({ secondary }) => (secondary ? BLUE_02 : BLUE_01)};
  color: ${({ secondary }) => (secondary ? BLUE_01 : WHITE)};

  &.rounded {
    border-radius: 40px !important;
  }
`;

interface LoadableButtonProps {
  children: ReactElement | ReactElement[] | string;
  className?: string;
  onClick: () => Promise<any>;
  disabled?: boolean;
}

export const LoadableButton: FC<LoadableButtonProps> = ({ children, className, onClick, disabled }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
    } catch (e) {
      console.error(e);
    }
    setIsLoading(false);
  };

  return (
    <NormalButton disabled={disabled || isLoading} className={className} onClick={handleClick}>
      {children}
    </NormalButton>
  );
};

export default NormalButton;
